<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="class['breadcrumb-object']['width']" [height]="class['breadcrumb-object']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu nzTitle="{{'kieu_hien_thi' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <nz-select [(ngModel)]="staticdata.content" (ngModelChange)="updateStaticData()">
          <nz-option nzValue="/tin tức" [nzLabel]="'trang_chinh' | translate"></nz-option>
          <nz-option nzValue="/trang chứa danh mục/danh mục 1" [nzLabel]="'trang_chua_danh_muc' | translate"></nz-option>
          <nz-option nzValue="/danh mục 1" [nzLabel]="'chi_tiet_danh_muc' | translate"></nz-option>
          <nz-option nzValue="/danh mục 1/sản phẩm 1" [nzLabel]="'chi_tiet_san_pham' | translate"></nz-option>
        </nz-select>
      </li>
      <!-- Canh lề tổng -->
      <li nz-submenu [nzTitle]="'canh_le_tong' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
        <div class="config-font">
          <div class="font">
            <!-- Canh trái -->
            <button class="font-text-btn" nz-button title="flex-start" 
              [nzType]="class['breadcrumb__wrapper']['justify-content'] === 'flex-start'
                ? 'primary'
                : 'default'" 
              (click)="
                class['breadcrumb__wrapper']['display'] = 'flex';
                class['breadcrumb__wrapper']['justify-content'] = 'flex-start'; 
                updateClass()">
              <i nz-icon nzType="align-left" nzTheme="outline"></i>
            </button>
            <!-- Canh giữa -->
            <button class="font-text-btn" nz-button title="center"
              [nzType]="class['breadcrumb__wrapper']['justify-content'] == 'center'
                ? 'primary'
                : 'default'" 
              (click)="
                class['breadcrumb__wrapper']['display'] = 'flex';
                class['breadcrumb__wrapper']['justify-content'] = 'center';
                updateClass()">
              <i nz-icon nzType="align-center" nzTheme="outline"></i>
            </button>
            <!-- Canh phải -->
            <button class="font-text-btn" nz-button title="flex-end"
              [nzType]="class['breadcrumb__wrapper']['justify-content'] == 'flex-end'
                ? 'primary'
                : 'default'" 
              (click)="
                class['breadcrumb__wrapper']['display'] = 'flex';
                class['breadcrumb__wrapper']['justify-content'] = 'flex-end';
                updateClass()">
              <i nz-icon nzType="align-right" nzTheme="outline"></i>
            </button>
          </div>
        </div>
      </li>

      <!-- HIỂN THỊ SỐ DÒNG -->
      <li nz-submenu [nzTitle]="'hien_thi_so_dong' | translate" [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
        <div class="field-row">
          <div class="config-name" style="gap:10px">
            <p class="m-0" style="line-height:1.5">{{'duong_dan_truoc' | translate}}</p>
            <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="1" [ngStyle]="{ width: '40%' }"
              [ngModel]="class['breadcrumb__wrapper--backlink']['-webkit-line-clamp'] | vhnumber"
              (ngModelChange)="class['breadcrumb__wrapper--backlink']['-webkit-line-clamp'] = $event" 
              (nzBlur)="updateClass(); functionService.updateDimension(objectChoosing._id)">
            </nz-input-number>
          </div>
        </div>
        <div class="field-row mt-2">
          <div class="config-name" style="gap:10px">
            <p class="m-0" style="line-height:1.5">{{'duong_dan_hien_tai' | translate}}</p>
            <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="1" [ngStyle]="{ width: '40%' }"
              [ngModel]="class['breadcrumb__wrapper--current']['-webkit-line-clamp'] | vhnumber"
              (ngModelChange)="class['breadcrumb__wrapper--current']['-webkit-line-clamp'] = $event" 
              (nzBlur)="updateClass(); functionService.updateDimension(objectChoosing._id)">
            </nz-input-number>
          </div>
        </div>
      </li>

      <!-- HIỆU ỨNG -->
      <li nz-submenu [nzTitle]="'hieu_ung' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['breadcrumb__wrapper--backlink']" [cursorClass2]="class['breadcrumb__wrapper--current']"
          [effect_hover]="effect_hover" [customize]="customize" [type]="'object'" [effectFileUsing]="'breadcrumb'">
        </app-choose-animations-config>
      </li>

      <!-- ĐƯỜNG DẪN TRƯỚC -->
      <div>
        <p style="font-weight: 500; margin: 16px 0 8px 0;">{{'duong_dan_truoc' | translate}}</p>
        <!-- CHỮ VÀ ĐỊNH DẠNG -->
        <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
          <div class="editor-field">
            <div class="editor-field-body">
              <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
                [config]="config" [staticdata]="staticdata"
                [textContentClass]="class['breadcrumb__wrapper--backlink']" [textWrapperClass]="class['breadcrumb__wrapper--backlink']">
              </app-text-format-config>
              <!-- Gradient -->
              <div class="config-font">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <p class="m-0" style="line-height:1.5">{{ 'do_mau_gradient' | translate }}<span style="font-size:13px">({{'da_sac' | translate}})</span></p>
                  <nz-switch [(ngModel)]="config['background-image-backlink'].gradient_check"
                    (ngModelChange)="handleSetGradientTextBacklink()">
                  </nz-switch>
                </div>
                <div class="container-gradient" *ngIf="config['background-image-backlink'].gradient_check">
                  <div class="list-gradient">
                    <button class="btn-gradient"
                      *ngFor="let bgGradient of config['background-image-backlink']['gradient_arr_gradient']; let i = index"
                      (click)="deleteGradientBacklink(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                      [disabled]="!config['background-image-backlink'].gradient_check">
                      <i class="delete-icon bi bi-x-circle"></i>
                    </button>
                  </div>
                  <p class="title-head">{{'them_mau' | translate}}</p>
                  <div class="container_add-gradient">
                    <button class="btn-add-gradient" nz-tooltip [nzTooltipTitle]="'them_mau' | translate"
                      [disabled]="!config['background-image-backlink'].gradient_check" (click)="openbgGradientBacklink()"
                      (blur)="addGradientBacklink()">
                      <input nz-input type="color" class="picking-gradient" id="input-gradient-backlink"
                        [(ngModel)]="config['background-image-backlink']['gradient_background_color']">
                      <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                    </button>
                    <div class="slide_container-gradient">
                      <input type="range" min="1" max="100" [value]="config['background-image-backlink']['gradient_opacity']"
                        class="slider-gradient" (input)="getValueRangeBackgroundGradientBacklink($event)"
                        [disabled]="!config['background-image-backlink'].gradient_check"
                        [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                    </div>
                    <div class="value-range">{{config['background-image-backlink']['gradient_opacity']}}%</div>
                  </div>
                  <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
                  <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
                    [nzTooltipTitle]="type.name | translate" (click)="chooseOptionBacklink(type, $event)"
                    [disabled]="!config['background-image-backlink'].gradient_check"
                    [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                    [ngClass]="{ 'active': config['background-image-backlink']['gradient_direction'] === type.direction}">
                  </button>
                </div>
              </div>
              <div class="field-row">
                <div class="config-font" style="margin-top:20px">
                  <!-- Khoảng cách chữ -->
                  <div class="font-text-letterspacing">
                    <div class="config-name" style="gap:5px">
                      <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                        [ngModel]="class['breadcrumb__wrapper--backlink']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                        (ngModelChange)="class['breadcrumb__wrapper--backlink']['letter-spacing'] = $event +'px'">
                      </nz-input-number>
                    </div>
                    <nz-row>
                      <nz-col nzSpan="24">
                        <nz-slider [nzMin]="0" [nzMax]="50"
                          [ngModel]="class['breadcrumb__wrapper--backlink']['letter-spacing'] | vhnumber"
                          (nzOnAfterChange)="updateClass();"
                          (ngModelChange)="class['breadcrumb__wrapper--backlink']['letter-spacing'] = $event +'px'">
                        </nz-slider>
                      </nz-col>
                    </nz-row>
                  </div>
                  <!-- Khoảng cách dòng -->
                  <div class="font-text-linespacing">
                    <div class="config-name">
                      <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_dong' | translate }}</p>
                      <nz-input-number [ngStyle]="{ width: '40%' }"
                        [(ngModel)]="this.class['breadcrumb__wrapper--backlink']['line-height']" (nzBlur)="updateClass()"
                        [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1">
                      </nz-input-number>
                    </div>
                    <nz-row>
                      <nz-col nzSpan="24">
                        <nz-slider [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                          [(ngModel)]="this.class['breadcrumb__wrapper--backlink']['line-height']" (nzOnAfterChange)="updateClass()">
                        </nz-slider>
                      </nz-col>
                    </nz-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

         <!-- THÊM LIÊN KẾT -->
        <li nz-submenu nzTitle="{{'them_lien_ket' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
          <div class="py-3">
            <div class="type-link">
              <p class="type-link__title mb-1">{{'chon_kieu_lien_ket' | translate}}</p>
              <nz-select class="type-link__select"
                [(ngModel)]="staticdata.type_link" 
                (ngModelChange)="updateStaticData()"
                [nzPlaceHolder]="'chon_kieu_lien_ket' | translate" allowClear>
              <nz-option *ngFor="let item of type_link" [nzValue]="item.value" [nzLabel]="item.label | translate"></nz-option>
            </nz-select>
            </div>
            <!-- Đến trang -->
            <div class="connect-page" *ngIf="staticdata.type_link == 'page_link'">
              <nz-select [(ngModel)]="selectedLink" 
                (ngModelChange)="updateStaticData()"
                [nzPlaceHolder]="'chon_trang_lien_ket' | translate" allowClear>
                <nz-option *ngFor="let page of arr_link_page" [nzValue]="page" [nzLabel]="page['name_' + functionService.selectedLanguageCode]"></nz-option>
              </nz-select>
            </div>
            <!-- Option cuộn lên đầu trang hay không -->
            <div *ngIf="staticdata.type_link == 'page_link' || staticdata.type_link == 'navigation_link'" class="my-3">
              <label for="scroll-select">{{'hanh_dong_khi_nhan'| translate}}:</label>
              <nz-select id="scroll-select" [(ngModel)]="staticdata.is_scroll" (ngModelChange)="updateStaticData()">
                <nz-option [nzValue]="true" [nzLabel]="'cuon_len_dau_trang' | translate"></nz-option>
                <nz-option [nzValue]="false" [nzLabel]="'giu_nguyen_vi_tri' | translate"></nz-option>
              </nz-select>
            </div>
          </div>
        </li>

      </div>

      <!-- ĐƯỜNG DẪN HIỆN TẠI -->
      <div>
        <p style="font-weight: 500; margin: 16px 0 8px 0;">{{'duong_dan_hien_tai' | translate}}</p>
        <!-- CHỮ VÀ ĐỊNH DẠNG -->
        <li nz-submenu [nzTitle]="'chu_va_dinh_dang' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
          <div class="editor-field">
            <div class="editor-field-body">
              <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
                [config]="config" [staticdata]="staticdata"
                [textContentClass]="class['breadcrumb__wrapper--current']" [textWrapperClass]="class['breadcrumb__wrapper--current']">
              </app-text-format-config>
              <!-- Gradient -->
              <div class="config-font">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <p class="m-0" style="line-height:1.5">{{ 'do_mau_gradient' | translate }}<span style="font-size:13px">({{'da_sac' | translate}})</span></p>
                  <nz-switch [(ngModel)]="config['background-image-current'].gradient_check"
                    (ngModelChange)="handleSetGradientTextCurrent()">
                  </nz-switch>
                </div>
                <div class="container-gradient" *ngIf="config['background-image-current'].gradient_check">
                  <div class="list-gradient">
                    <button class="btn-gradient"
                      *ngFor="let bgGradient of config['background-image-current']['gradient_arr_gradient']; let i = index"
                      (click)="deleteGradientCurrent(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                      [disabled]="!config['background-image-current'].gradient_check">
                      <i class="delete-icon bi bi-x-circle"></i>
                    </button>
                  </div>
                  <p class="title-head">{{'them_mau' | translate}}</p>
                  <div class="container_add-gradient">
                    <button class="btn-add-gradient" nz-tooltip [nzTooltipTitle]="'them_mau' | translate"
                      [disabled]="!config['background-image-current'].gradient_check" (click)="openbgGradientCurrent()"
                      (blur)="addGradientCurrent()">
                      <input nz-input type="color" class="picking-gradient" id="input-gradient-current"
                        [(ngModel)]="config['background-image-current']['gradient_background_color']">
                      <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                    </button>
                    <div class="slide_container-gradient">
                      <input type="range" min="1" max="100" [value]="config['background-image-current']['gradient_opacity']"
                        class="slider-gradient" (input)="getValueRangeBackgroundGradientCurrent($event)"
                        [disabled]="!config['background-image-current'].gradient_check"
                        [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                    </div>
                    <div class="value-range">{{config['background-image-current']['gradient_opacity']}}%</div>
                  </div>
                  <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
                  <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
                    [nzTooltipTitle]="type.name | translate" (click)="chooseOptionCurrent(type, $event)"
                    [disabled]="!config['background-image-current'].gradient_check"
                    [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                    [ngClass]="{ 'active': config['background-image-current']['gradient_direction'] === type.direction}">
                  </button>
                </div>
              </div>
              <div class="field-row">
                <div class="config-font" style="margin-top:20px">
                  <!-- Khoảng cách chữ -->
                  <div class="font-text-letterspacing">
                    <div class="config-name" style="gap:5px">
                      <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                        [ngModel]="class['breadcrumb__wrapper--current']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                        (ngModelChange)="class['breadcrumb__wrapper--current']['letter-spacing'] = $event +'px'">
                      </nz-input-number>
                    </div>
                    <nz-row>
                      <nz-col nzSpan="24">
                        <nz-slider [nzMin]="0" [nzMax]="50"
                          [ngModel]="class['breadcrumb__wrapper--current']['letter-spacing'] | vhnumber"
                          (nzOnAfterChange)="updateClass();"
                          (ngModelChange)="class['breadcrumb__wrapper--current']['letter-spacing'] = $event +'px'">
                        </nz-slider>
                      </nz-col>
                    </nz-row>
                  </div>
                  <!-- Khoảng cách dòng -->
                  <div class="font-text-linespacing">
                    <div class="config-name">
                      <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_dong' | translate }}</p>
                      <nz-input-number [ngStyle]="{ width: '40%' }"
                        [(ngModel)]="this.class['breadcrumb__wrapper--current']['line-height']" (nzBlur)="updateClass()"
                        [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1">
                      </nz-input-number>
                    </div>
                    <nz-row>
                      <nz-col nzSpan="24">
                        <nz-slider [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                          [(ngModel)]="this.class['breadcrumb__wrapper--current']['line-height']" (nzOnAfterChange)="updateClass()">
                        </nz-slider>
                      </nz-col>
                    </nz-row>
                  </div>

                  <div style="display: flex; align-items: center; justify-content: space-between;">
                    <p class="m-0" style="line-height:1.5">{{'xuong_dong_doi_voi_duong_hien_tai' | translate}}</p>
                    <nz-switch [(ngModel)]="config['new-line-current']"
                      (ngModelChange)="updateConfig()">
                    </nz-switch>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </div>
      <li nz-submenu nzTitle="{{'cau_hinh_icon' | translate}}" [(nzOpen)]="openMap.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <div class=my-3>
          <p class="mb-2">{{'kieu_icon' | translate}}</p>
          <nz-select [(ngModel)]="staticdata.icon_type" (ngModelChange)="updateStaticData()">
            <nz-option nzValue="icon" nzLabel="Icon"></nz-option>
            <nz-option nzValue="text" nzLabel="Chữ"></nz-option>
          </nz-select>
        </div>

        <!-- Dạng icon -->
        <ng-container *ngIf="staticdata.icon_type === 'icon'">
          <div class="field-row">
            <!-- Chọn icon -->
            <div class="d-flex justify-content-between mx-1">
              <mat-icon [title]="staticdata.icon">{{ staticdata.icon }}</mat-icon>
              <button nz-button nzType="default" (click)="openDialogChooseIcon()" style="border-radius: 5px">
                {{ "thay_doi" | translate }}
              </button>
            </div>
          </div>
        </ng-container>

        <!-- Dạng chữ -->
        <ng-container *ngIf="staticdata.icon_type === 'text'">
          <div class="field-row">
            <!-- Nhập chữ -->
            <mat-form-field style="width:100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea style="height:80px;background: #edf6fd;
                padding:10px 6px;font-size:13px;border-top-left-radius:5px;
                border-top-right-radius:5px" matInput 
                [(ngModel)]="staticdata.text"
                (blur)="updateStaticData()"></textarea>
            </mat-form-field>
          </div>
        </ng-container>

        <div class="field-row">
          <!-- Màu icon -->
          <div class="color-pick mt-4">
            <span>{{ "mau_bieu_tuong" | translate }}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true" 
              [(colorPicker)]="class['breadcrumb__wrapper--icon']['color']"
              [style.background]="class['breadcrumb__wrapper--icon']['color']" 
              (colorPickerClose)="updateClass()"
              [cpWidth]="'230px'" />
          </div>
          <!-- Kích thước -->
          <ng-container>
            <nz-row class="config-name mt-4">
              <p class="m-0">{{ "kich_thuoc" | translate }}</p>
              <nz-input-number [nzMin]="1" [nzMax]="200" [nzStep]="1" 
                [ngStyle]="{ marginLeft: '10px' }"
                [ngModel]="class['breadcrumb__wrapper--icon']['font-size'] | vhnumber" 
                (ngModelChange)="class['breadcrumb__wrapper--icon']['font-size'] = $event + 'px'" 
                (nzBlur)="updateClass()">
              </nz-input-number>
            </nz-row>
            <nz-col nzSpan="24">
              <nz-slider [nzMin]="1" [nzMax]="200" [nzStep]="1"
                [ngModel]="class['breadcrumb__wrapper--icon']['font-size'] | vhnumber" 
                (ngModelChange)="class['breadcrumb__wrapper--icon']['font-size'] = $event + 'px'" 
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </nz-col>
          </ng-container>
          <!-- Khoảng cách bên trái -->
          <ng-container>
            <nz-row class="config-name mt-4">
              <p class="m-0" style="line-height: 1.5; flex: 1">{{ "khoang_cach_ben_trai" | translate }}</p>
              <nz-input-number [nzMin]="0" [nzMax]="200" [nzStep]="1" 
                [ngStyle]="{ marginLeft: '10px' }"
                [ngModel]="class['breadcrumb__wrapper--icon']['margin-left'] | vhnumber" 
                (ngModelChange)="class['breadcrumb__wrapper--icon']['margin-left'] = $event + 'px'" 
                (nzBlur)="updateClass()">
              </nz-input-number>
            </nz-row>
            <nz-col nzSpan="24">
              <nz-slider [nzMin]="0" [nzMax]="200" [nzStep]="1"
                [ngModel]="class['breadcrumb__wrapper--icon']['margin-left'] | vhnumber" 
                (ngModelChange)="class['breadcrumb__wrapper--icon']['margin-left'] = $event + 'px'" 
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </nz-col>
          </ng-container>
          <!-- Khoảng cách bên phải -->
          <ng-container>
            <nz-row class="config-name mt-4">
              <p class="m-0" style="line-height: 1.5; flex: 1">{{ "khoang_cach_ben_phai" | translate }}</p>
              <nz-input-number [nzMin]="0" [nzMax]="200" [nzStep]="1" 
                [ngStyle]="{ marginLeft: '10px' }"
                [ngModel]="class['breadcrumb__wrapper--icon']['margin-right'] | vhnumber" 
                (ngModelChange)="class['breadcrumb__wrapper--icon']['margin-right'] = $event + 'px'" 
                (nzBlur)="updateClass()">
              </nz-input-number>
            </nz-row>
            <nz-col nzSpan="24">
              <nz-slider [nzMin]="0" [nzMax]="200" [nzStep]="1"
                [ngModel]="class['breadcrumb__wrapper--icon']['margin-right'] | vhnumber" 
                (ngModelChange)="class['breadcrumb__wrapper--icon']['margin-right'] = $event + 'px'" 
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </nz-col>
          </ng-container>
        </div>
      </li>
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>